import { AbstractDTO } from "./../abstract";
import { ComponentDTO } from "./component";
import { ComponentFullDTO } from "./component-full";

// @dynamic
export class OptionDTO extends AbstractDTO {
    key: string;
    value: string;
    image: string;
    alt: string;
    exclusive: string;
    compExplain: string

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.key = attributes['key'] || '';
        this.value = attributes['value'] || '';
        this.image = attributes['image'] || '';
        this.alt = attributes['alt'] || '';
        this.exclusive = attributes['exclusive'] || '';
        this.exclusive = attributes['compExplain'] || '';
		Object.assign(this, attributes);
    }

    static createFromComponents(collection: object[], full = false): any {
        return (collection || []).map((attributes) => {
            if(attributes instanceof ComponentFullDTO && !full) {
				attributes = ComponentDTO.create(attributes);
            }
            attributes['key'] = attributes['compCode'];
            attributes['value'] = attributes['compName'];
            attributes['alt'] = attributes['compAlt'];
			delete attributes['compCode'];
			delete attributes['compName'];
			delete attributes['compAlt'];
            return new this(attributes || {});
        });
    }

    static createFromCodesc(collection: object[]) {
        return (collection || []).map((attributes) => {
            attributes['key'] = attributes['value'];
            attributes['value'] = attributes['title'];
            return new this(attributes || {});
        });
    }

    static createFromCngProducts(collection: object[]) {
        return (collection || []).map((attributes) => {
            attributes['key'] = attributes['id'];
            attributes['value'] = attributes['name'];
            return new this(attributes || {});
        });
    }

    static createFromUsersList(collection: object[]) {
        return (collection || []).map((attributes) => {
            attributes['key'] = attributes['user_id'];
            attributes['value'] = attributes['name'];
            return new this(attributes || {});
        });
    }
}
